import React from "react";
import { Container, Row } from "reactstrap";
import CountUp from 'react-countup';

export default function EstadisticasSection({ data }) {
    const { contadores, blockType, __component } = data;
    const ancla = blockType || __component?.split('.')[1] || 'estadisticas';

    if (!contadores || contadores.length === 0) return null;

    return (
        <section className="section" id={ancla}>
            <Container>
                <Row>
                    {contadores.map((contador, index) => (
                        <div key={index} className="col-md-3 col-6">
                            <div className="counter-box position-relative text-center">
                                <h3 className="mb-0 fw-semibold mt-2">
                                    <CountUp
                                        className="counter-value"
                                        start={0}
                                        end={contador.numero}
                                        delay={2}
                                    />
                                    {contador.sufijo || '+'}
                                </h3>
                                <span className="counter-head text-muted">{contador.etiqueta}</span>
                            </div>
                        </div>
                    ))}
                </Row>
            </Container>
        </section>
    );
}
